<template>
  <div class="">
    <!-- phantom content -->
  </div>
</template>

<script>
  import '../../assets/js/jquery.min.js';
  import '../../assets/js/bootstrap.min.js';
  import '../../assets/js/slick.min.js';
  import '../../assets/js/aos.js';
  import '../../assets/js/syotimer.min.js';
  import '../../assets/js/script.js';

  // import '../assets/js/fancybox.min.js';
  // import '../assets/js/gmap.js';

  export default { }
</script>

<style scoped>
  
</style>